import { PageSpinner, useToastStore } from '@branch-messenger/willow-ui'
import { FC, use, useState } from 'react'

import { DialogContext } from '@/context'
import { DebitCardType } from '@/types/card'

import { useConnectedCardInfo } from '../connectedDebitCards/hooks/useConnectedCardInfo'
import { DebitCardForm } from '../DebitCard/DebitCardForm'
import {
  DebitCardModalContentContainer,
  DebitCardModalLoaderBackground,
} from './styles'

type DebitCardModalContentProps = {
  type: DebitCardType
  onDebitCardFormClosed?: () => void
  onDebitCardFormSuccess?: () => void
}

export const DebitCardModalContent: FC<DebitCardModalContentProps> = ({
  type,
  onDebitCardFormClosed,
  onDebitCardFormSuccess,
}) => {
  const { hideDialog } = use(DialogContext)
  const { title } = useConnectedCardInfo(type)
  const [loaded, setLoaded] = useState(false)
  const addToast = useToastStore(state => state.addToast)
  const handleSuccess = () => {
    hideDialog()
    addToast({
      variant: 'success',
      title: `Your card for ${title.toLowerCase()} has been successfully updated`,
    })
    if (onDebitCardFormSuccess) {
      onDebitCardFormSuccess()
    }
  }

  const handleClose = () => {
    hideDialog()
    if (onDebitCardFormClosed) {
      onDebitCardFormClosed()
    }
  }

  return (
    <DebitCardModalContentContainer>
      <PageSpinner open={!loaded} />
      {!loaded && <DebitCardModalLoaderBackground />}
      <DebitCardForm
        type={type}
        handleClose={handleClose}
        handleOnLoad={() => setLoaded(true)}
        handleSuccess={handleSuccess}
      />
    </DebitCardModalContentContainer>
  )
}
